import { render, staticRenderFns } from "./TechnicalWork.vue?vue&type=template&id=5addd50b"
import script from "./TechnicalWork.vue?vue&type=script&lang=ts"
export * from "./TechnicalWork.vue?vue&type=script&lang=ts"
import style0 from "./TechnicalWork.vue?vue&type=style&index=0&id=5addd50b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports